// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: 'AIzaSyBHXCYDoNHe3a12Zom5FAiUqHdNsN3B1c8',
    authDomain: 'melabev-89f3f.firebaseapp.com',
    databaseURL: 'https://melabev-89f3f.firebaseio.com',
    projectId: 'melabev-89f3f',
    storageBucket: 'melabev-89f3f.appspot.com',
    messagingSenderId: '797978208154',
    appId: '1:797978208154:web:4d42a2bdfd8de7346bfc23',
    measurementId: 'G-1F8LTQERRL'
  },

  zoom: {
    apiKey: '3OYQcRNISWqhqa0HTwD00g',
  },

  endpoint: 'https://europe-west1-melabev-89f3f.cloudfunctions.net/api'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
